import { TableCell, TableCellProps } from "@mui/material";
import { styled } from "@mui/material/styles";

interface IStyledTableCellProps extends TableCellProps {
  isOnlyPage?: boolean;
}

export const StyledTableCell = styled(TableCell, {
  shouldForwardProp: prop => prop !== "isOnlyPage",
})<IStyledTableCellProps>(({ theme, isOnlyPage }) => ({
  borderBottom: "1px solid #ebebf7",
  borderLeft: "none",
  borderRight: "none",
  fontSize: 12,
  padding: theme.spacing(0.5),

  [theme.breakpoints.up("xl")]: {
    fontSize: 14,
    padding: theme.spacing(1),
  },
  [theme.breakpoints.up("xxl")]: {
    fontSize: 16,
    padding: theme.spacing(1),
  },

  ...(isOnlyPage && {
    fontSize: 16,
    padding: theme.spacing(1),
  }),
}));
